<template>
  <div class="box" v-if="show">
    <div class="left_box"></div>
    <div class="right_box"></div>
    <div class="contant flex">
      <div class="left_category">
        <div :class="{ active: item.id == ids }" class="item"
          v-for="(item, index) in majorClassList" :key="index"
          @click.stop="selectCategory(item, index)">
          {{ item.name }}
        </div>
      </div>
      <div class="right_category_title">
        <div class="right_category">
          <div class="right_category_item" v-for="(item, index) in list" :key="index">
            <p class="title">
              <span>{{ item.name }}</span>
              <!-- <img src="@/assets/images/arrows.png" alt="" class="arrows img-ico"> -->
            </p>
            <div class="border_category"></div>
            <div v-for="(eve, i) in item.basicMajorList" :key="i" @click.stop="goCourseCenter(eve)">
              <p class="course_name">
                <span>{{ eve.name }}</span>
                <!-- 误删 start -->
                <!-- <img src="@/assets/images/hot.png" alt="" class="hot img-ico" v-if="false">
                <img src="@/assets/images/hot.png" alt="" class="new img-ico" v-else> -->
                <!-- 误删 end -->
              </p>
            </div>
          </div>
        </div>
        <div class="right_category_recommend" v-show="isShow">
          <p>为你推荐</p>
          <div class="recommend_one"></div>
          <p>热门排行</p>
          <div class="recommend_two" v-for="item in 2" :key="item">
            <span class="two_left">01</span>
            <div class="two_right">
              <p class="two_title">道路与桥梁工程施工</p>
              <p class="two_content"><span>上海交通大学</span><span>王冲锋</span></p>
              <p class="two_content">458745人参与</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProfessionalSubclass, getMajor } from '@/api/personage.js';
export default {
  props: {
    // zzmajorClassList: {
    //   type: Array,
    //   default: null,
    // },
    // gzmajorClassList: {
    //   type: Array,
    //   default: null,
    // },
    // secondaryClassList: {
    //   type: Array,
    //   default: [],
    // },
    id: {
      type: String,
      default: '',
    },
    active: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: false,
      list: [],
      isShow: false,
      arr: [],
      majorClassList: [],
      majorClassId: '', //专业大类id
      ids: '',
    };
  },
  mounted() {
    this.ids = this.id;
    this.init();
  },
  methods: {
    init() {
      this.show = true;
      if (this.active == 'GZ') {
        this.majorClassList = this.$store.state.gzMajorTree;
      } else {
        this.majorClassList = this.$store.state.zzMajorTree;
      }
      this.ids = this.majorClassList[0]?this.majorClassList[0].id:"";
      this.majorClassId = this.majorClassList[0]?this.majorClassList[0].id:"";
      this.list = this.majorClassList[0]?this.majorClassList[0].basicMajorSubclassList:[];
      // this.$store.commit('majorClassId', this.majorClassList[0]?this.majorClassList[0].id:"");
      // this.$store.commit('majorClassName', this.majorClassList[0]?this.majorClassList[0].name:"");
      // this.getProfessionalSubclass(this.id);
    },
    selectCategory(item, i) {
      this.ids = item.id;
      if (item.classify == 'GZ') {
        this.$parent.gzId = item.id;
      } else {
        this.$parent.zzId = item.id;
      }
      this.majorClassId = item.id;
      this.majorClassList.forEach((row) => {
        if (row.id == item.id) {
          this.list = row.basicMajorSubclassList;
        }
      });
      this.$store.commit('majorClassId', item.id);
      this.$store.commit('majorClassName', item.name);
      // this.getProfessionalSubclass(item.id);
    },
    goCourseCenter(item) {
      this.$router.push({
        name: 'goCourseCenterlBack',
        query: {
          type: this.active,
        },
      });
      this.$store.commit('majorClassId', this.majorClassId);
      this.$store.commit('majorId', item.id);
      localStorage.setItem('courseType', this.active);
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  position: absolute;
  left: 0;
  top: 80px;
  margin-left: 0 !important;
  width: 100%;
  height: 472px;
  z-index: 3;
  color: #333333;
  box-shadow: 0px 4px 8px 2px rgba(210, 210, 210, 0.4);
  background: linear-gradient(
    to right,
    #f3f5f9 0%,
    #f3f5f9 25%,
    #f6f9ff 25%,
    #f6f9ff 100%
  );
  box-sizing: border-box;
  .left_box {
    width: 150vw;
    background: #f3f5f9;
    height: 475px;
    position: absolute;
    z-index: -1;
    margin-left: -50vw;
    margin-top: -3px;
    background: linear-gradient(
      to right,
      #f3f5f9 0%,
      #f3f5f9 40%,
      #f6f9ff 40%,
      #f6f9ff 100%
    );
    box-shadow: 0px 4px 8px 2px rgba(132, 133, 133, 0.4);
  }
}
.contant {
  width: 1200px;
  margin: 0 auto;
  height: 100%;
  overflow: hidden;
  .left_category {
    width: 18%;
    height: 100%;
    overflow-y: auto;
    background-image: url(~@/assets/images/left-select.png);
    background-color: #f3f5f9;
    background-repeat: no-repeat;
    background-size: 60% 100%;
    background-position-x: right;
    padding: 17px 0;
    box-sizing: border-box;
    .item {
      width: 96%;
      height: 42px;
      line-height: 42px;
      padding-left: 20px;
      cursor: pointer;
      box-sizing: border-box;
      font-size: 16px;
      color: #333333;
      font-weight: 400;
    }
    .item:hover,
    .active {
      background: rgba(0, 91, 255, 0.22);
    }
  }
  .right_category_title {
    width: 82%;
    padding: 20px 60px;
    max-height: 672px;
    overflow-y: auto;
    position: relative;
    // background: #ffffff;
    box-sizing: border-box;
    .right_category {
      width: 100%;
      // background: #ffffff;
      // -webkit-box-sizing: border-box;
      box-sizing: border-box;
      // -webkit-column-count: 1;
      // -moz-column-count: 1;
      // column-count: 1;
      // -moz-column-gap: 125px;
      // column-gap: 125px;
      column-gap: 10px;
      column-count: 3;
      margin: 0 auto;
      .right_category_item {
        // width: 90%;
        margin-bottom: 50px;
        box-sizing: border-box;
        -webkit-column-break-inside: avoid; /* Chrome, Safari, Opera */
        page-break-inside: avoid; /* Firefox */
        break-inside: avoid; /* IE 10+ */
        padding: 10px;
        counter-increment: item-counter;
        height: 100%;
        overflow: auto;
        .title {
          font-size: 18px;
          font-weight: bold;
          color: #006cff;
          line-height: 20px;
        }
        .border_category {
          width: 100%;
          height: 1px;
          background: #bcc1d2;
          margin: 20px 0 15px;
        }
        .course_name {
          width: 100%;
          line-height: 42px;
          font-size: 16px;
          color: #333;
          cursor: pointer;
          font-weight: 400;
        }
        .course_name:hover {
          color: #006cff;
        }
      }
    }
    .right_category_recommend {
      position: absolute;
      top: 30px;
      right: 68px;
      p {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 20px;
        line-height: 20px;
      }
      .recommend_one {
        width: 357px;
        height: 185px;
        background-color: #bbb;
        border-radius: 10px;
        margin-bottom: 60px;
      }
      .recommend_two {
        width: 357px;
        height: 102px;
        background-image: linear-gradient(#f5f6f8, #fdfdff);
        border: 1px solid #e8e8e8;
        position: relative;
        margin-bottom: 20px;
        .two_left {
          font-size: 22px;
          font-weight: 400;
          color: #596d93;
          line-height: 32px;
          position: absolute;
          top: 23px;
          left: 30px;
        }
        .two_right {
          display: inline-block;
          position: absolute;
          left: 76px;
          top: 15px;
          .two_title {
            font-size: 14px;
            font-weight: 400;
            color: #596d93;
            margin-bottom: 7px;
          }
          .two_content {
            font-size: 13px;
            font-weight: 400;
            color: #9faab8;
            span {
              margin-right: 40px;
            }
            margin-bottom: 7px;
          }
        }
      }
    }
  }
}
.left_category::-webkit-scrollbar,
.right_category_title::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 7px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.left_category::-webkit-scrollbar-thumb,
.right_category_title::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 7px;
  //   -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  //   background: #7D8691;
  background: rgba(125, 134, 145, 0.1);
  border: none;
}

.left_category::-webkit-scrollbar-track,
.right_category_title::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  //   -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  background: #f3f5f9;
}
.img-ico {
  width: 32px;
  height: 16px;
  margin-right: 10px;
}
.arrows{
  width: 16px !important;
  height: 16px;
  margin-right: 30px !important;
  position: relative;
  top: 2px;
}
</style>